module.exports = __webpack_public_path__ + "img/login.c0d64632.png";